import { Button, Grid, Typography, TextField, Box, Hidden, IconButton } from "@mui/material";
import { Search as IconSearch, CheckCircle as IconCheck } from "@mui/icons-material";
import * as sesionService from "../../services/sesionService";
import * as personaService from "../../services/personaService";
import { obtenerPerfil } from "../../services/usuarioService";
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { setValue, setResults } from '../../redux/sesionTerapeutaSearchSlice';
import DialogYesNo from '../../components/DialogYesNo';
import DataGridBase from "../../components/common/DataGridBase"

// Navegabilidad del terapeuta: ve las sesiones que ha registrado. El
// terapeuta es el usuario logueado (fijo, no es un filtro) y puede
// modificar una sesion mientras no este validada; desde aqui la valida.
const Index = () => {
    const filters = useSelector((state) => state.sesionTerapeutaSearch.filters);
    const accesos = useSelector((state) => state.seguridad?.accesos || []);

    const [idTerapeuta, setIdTerapeuta] = useState(0);
    const [nombreTerapeuta, setNombreTerapeuta] = useState("");
    const [esTerapeuta, setEsTerapeuta] = useState(false);
    const [cargando, setCargando] = useState(true);
    const [results, setResults] = useState([]);
    const dispatch = useDispatch();

    const [openDialogValidar, setOpenDialogValidar] = useState(false);
    const [selectId, setSelectId] = useState(null);

    const fetchResults = async (idTerapeuta) => {
        setCargando(true);

        await sesionService.getsSesionResumenView({
                idTerapeuta: idTerapeuta,
                participante: filters.participante,
                idPeriodo: 0,
                fechaInicio: filters.fechaInicio,
                fechaFin: filters.fechaFin,
                idEstado: 0,
            })
            .then((data) => {
                setResults(data);
                setCargando(false);
            })
            .catch((err) => {
                setCargando(false);
                console.log("Err: ", err)
            });
    }

    // El terapeuta de esta pantalla es el usuario logueado: su persona sale
    // de su perfil. Solo los terapeutas (idTipoPersona=25) pueden ver sus sesiones.
    const resolverTerapeuta = async () => {
        const perfil = await obtenerPerfil().catch(() => null);
        const id = perfil?.idPersona || 0;
        setIdTerapeuta(id);
        setNombreTerapeuta(perfil?.nombres || "");

        // Verificar si la persona es terapeuta (idTipoPersona = 25 o permisos de terapeuta)
        let terapeuta = false;
        if (id > 0) {
            const tipo = await personaService.getPersonaResumenBasicoById(id).catch(() => null);
            if (tipo === 25 || accesos.includes("sesionTerapeuta.ver") || accesos.includes("terapiaPlanTerapeuta.ver")) {
                terapeuta = true;
            }
        }
        setEsTerapeuta(terapeuta);

        if (terapeuta) {
            fetchResults(id);
        }
    }

    useEffect(() => {
        resolverTerapeuta();
    }, []);

    // El terapeuta solo valida. Desvalidar es una correccion de supervision y
    // se hace desde la ventana general de sesiones, asi que no se ofrece aqui.
    const validar = async () => {
        await sesionService.validarSesion(selectId)
            .catch((err) => { console.log("Err: ", err) });
        setOpenDialogValidar(false);
        fetchResults(idTerapeuta);
    }

    const columns = [
        { field: 'id', headerName: 'ID', width: 50, minWidth: 45, sortable: true, headerAlign: 'center', align: 'center',
            renderCell: (p) => <span style={{ fontSize: '0.75rem', color: '#666', fontFamily: 'monospace' }}>{p.value != null ? p.value : p.row.id}</span> },
        { field: 'participante', headerName: 'Participante', width: 175, sortable: false, headerAlign: 'center'
            , renderCell: (cellValues) => {
                return <Link to={'/session/edit/' + cellValues.row.id + '/' + cellValues.row.idTerapiaPeriodo} style={{ color: 'inherit' }}>{cellValues.row.participante}</Link>;
            }
        },
        { field: 'codigoPeriodo', headerName: 'Periodo', width: 90, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'fecha', headerName: 'Fecha', width: 100, type: 'date'
            , valueFormatter: (value) => moment(value).format('DD/MM/YYYY')
            , sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'estadoAsistencia', headerName: 'Asistencia', width: 100, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'modalidad', headerName: 'Modalidad', width: 100, sortable: false, headerAlign: 'center', align: 'center' },
        { field: 'estadoValidacion', headerName: 'Validacion', width: 100, sortable: false, headerAlign: 'center', align: 'center' },
        // Solo se ofrece validar. Si ya esta validada no hay nada que hacer
        // desde aqui: desvalidar es de supervision.
        { field: 'validar', headerName: '', width: 90, sortable: false, headerAlign: 'center', align: 'center'
            , renderCell: (cellValues) => {
                const validado = cellValues.row.idEstadoValidacion === 310;
                if (validado) return "";

                return <IconButton aria-label="validar" size='small' style={{ height: 10 }} align={"center"} onClick={() => {
                    setSelectId(cellValues.row.id);
                    setOpenDialogValidar(true);
                }}>
                    <IconCheck />
                </IconButton>;
            }
        },
    ];

    return (
        <div>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        {nombreTerapeuta || (esTerapeuta === false ? "No es un terapeuta" : "Cargando...")}
                    </Typography>
                </Grid>
                {!esTerapeuta && idTerapeuta > 0 && (
                    <Grid item xs={12}>
                        <Typography variant="body1" color="warning.main" sx={{ pt: 2 }}>
                            Este usuario no está registrado como terapeuta. Solo los terapeutas pueden ver sus sesiones asignadas.
                        </Typography>
                    </Grid>
                )}
                {esTerapeuta && (
                    <Grid item xs={12}>
                        <Grid container spacing={1} padding={"12px 0px 0px 0px"}>
                            <Grid item xs={12} sm={12}>
                                <Grid container item xs={12} sm={12} spacing={1} padding={0}>
                                    <Grid item xs={8} sm={3}>
                                        <TextField
                                            name="participante"
                                            label="Participante"
                                            value={filters.participante}
                                            fullWidth
                                            onChange={(event) => {
                                                dispatch(setValue({name: "participante", value: event.target.value}))
                                            }}
                                            onKeyDown={(event) => {
                                                if (event.key === "Enter") {
                                                    event.preventDefault();
                                                    fetchResults(idTerapeuta);
                                                }
                                            }}
                                            size="small"
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={3} lg={2}>
                                        <TextField
                                            name="fechaInicio"
                                            label="Inicio"
                                            fullWidth
                                            type="date"
                                            value={moment(filters.fechaInicio).format('yyyy-MM-DD')}
                                            onChange={(event) => {
                                                dispatch(setValue({name: "fechaInicio", value: event.target.value}))
                                            }}
                                            onKeyDown={(event) => {
                                                if (event.key === "Enter") {
                                                    event.preventDefault();
                                                    fetchResults(idTerapeuta);
                                                }
                                            }}
                                            size="small"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={6} sm={4} md={3} lg={2}>
                                        <TextField
                                            name="fechaFin"
                                            label="Fin"
                                            fullWidth
                                            type="date"
                                            value={moment(filters.fechaFin).format('yyyy-MM-DD')}
                                            onChange={(event) => {
                                                dispatch(setValue({name: "fechaFin", value: event.target.value}))
                                            }}
                                            onKeyDown={(event) => {
                                                if (event.key === "Enter") {
                                                    event.preventDefault();
                                                    fetchResults(idTerapeuta);
                                                }
                                            }}
                                            size="small"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>
                                    <Grid item xs={4} sm={1} display={"flex"} alignItems={"center"}>
                                        <Button variant="outlined" size="medium" fullWidth onClick={() => {
                                            fetchResults(idTerapeuta)
                                        }}>
                                            {<Hidden smDown></Hidden>}
                                            <IconSearch />
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Box sx={{ display: 'grid', gridTemplateColumns: '1fr' }}>
                                    <DataGridBase
                                        rows={results}
                                        columns={columns}
                                        loading={cargando}
                                    />
                                </Box>
                            </Grid>
                            <DialogYesNo open={openDialogValidar} openClose={() => setOpenDialogValidar(!openDialogValidar)} setYes={validar}
                                setNo={() => { return }}
                                titulo={"Validar Sesion"}
                                texto={"Esta seguro de validar la sesion? Una vez validada ya no se puede modificar."} >
                            </DialogYesNo>
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </div>
    )
}
export default Index